{
  "home": "Bosh sahifa",
  "games": "Oyinlar",
  "casino": "Kazino",
  "sports": "Sport",
  "bonuses": "Bonuslar",
  "wallet": "Kassa",
  "menu": "Menyu",
  "profile": "Kabinet",
  "login": "Kirish",
  "loginSoon": "Kirish — tez orada",
  "vipCashback": "VIP Cashback",
  "invite": "Taklif"
}
